import {
  isWorkType,
  type WorkType,
} from "./shift-code-add-dialog-utils";

export type ShiftCodeFormInitialValue = {
  readonly shift_id: string;
  readonly name: string;
  readonly description?: string | null;
  readonly color: string;
  readonly start_time: string | null;
  readonly end_time: string | null;
  readonly type: string;
  readonly shift_gb?: string | null;
  readonly show_in_preference?: boolean;
  readonly off_swap_target?: boolean;
  readonly health_leave_target?: boolean;
  readonly sleep_off_target?: boolean;
  readonly default_shift?: string | null;
};

export type ShiftCodeFormSubmitValue = {
  readonly shift_id: string;
  readonly name: string;
  readonly description: string | null;
  readonly color: string;
  readonly start_time: string | null;
  readonly end_time: string | null;
  readonly type: string;
  readonly shift_gb: string | null;
  readonly show_in_preference: boolean;
  readonly off_swap_target: boolean;
  readonly health_leave_target: boolean;
  readonly sleep_off_target: boolean;
  readonly slotIndex: number;
};

export function resolveWorkType(value: string): WorkType {
  if (isWorkType(value)) return value;
  if (value === "휴무" || value === "연차") return "휴가";
  return "근무";
}

export function getOffSwapUnavailableMessage({
  type,
  defaultShift,
  shiftGb,
  offSwapOffShiftGb,
}: {
  readonly type: string;
  readonly defaultShift?: string | null;
  readonly shiftGb?: string | null;
  readonly offSwapOffShiftGb?: string | null;
}) {
  const condition =
    "설정 가능 조건: 타입이 공가 또는 휴가이고, 기본 OFF 코드가 아니며, 기본 OFF와 구분이 달라야 합니다.";

  if (type === "근무") {
    return `${condition} 현재 코드는 타입이 근무라 설정할 수 없습니다.`;
  }
  if (defaultShift === "O") {
    return `${condition} 현재 코드는 기본 OFF 코드라 대체 코드로 지정할 수 없습니다.`;
  }
  if (offSwapOffShiftGb && shiftGb === offSwapOffShiftGb) {
    return `${condition} 현재 코드는 기본 OFF와 구분이 같아 설정할 수 없습니다.`;
  }
  return condition;
}
